import React from 'react';

const getRegionBadgeClass = (value) => {
  if (value === 'APJ') {
    return 'bootcamp-pill-region-apj';
  }
  if (value === 'EMEA') {
    return 'bootcamp-pill-region-emea';
  }
  if (value === 'NA') {
    return 'bootcamp-pill-region-na';
  }
  if (value === 'LATAM') {
    return 'bootcamp-pill-region-latam';
  }
  return '';
};

const getProgressPercent = (item) => {
  const total = item?.total || 0;
  const certified = item?.certified || 0;

  if (item?.completionRate != null && Number.isFinite(Number(item.completionRate))) {
    return Math.min(100, Math.max(0, Number(item.completionRate)));
  }

  return total ? Math.round((certified / total) * 100) : 0;
};

const TopCountriesCertificationsCard = ({
  countries = [],
  exportId = 'export-top-countries',
}) => {
  return (
    <section id={exportId} className="bootcamp-card bootcamp-top-countries-card bootcamp-paired-card">
      <h3>Top Countries — Certifications</h3>

      <div className="bootcamp-card-body">
        <div className="bootcamp-top-countries-list bootcamp-paired-scroll">
          {countries.map((item) => {
            const progressPercent = getProgressPercent(item);

            return (
              <article
                className="bootcamp-country-row-card"
                key={`${item.country}-${item.region}`}
              >
                <div className="bootcamp-country-row-header">
                  <div className="bootcamp-country-name-wrap">
                    <strong className="bootcamp-country-name">{item.country}</strong>
                    <span
                      className={`bootcamp-region-badge bootcamp-pill ${getRegionBadgeClass(item.region)}`}
                    >
                      {item.region}
                    </span>
                  </div>

                  <div className="bootcamp-country-count">
                    <span className="bootcamp-country-count-certified">{item.certified || 0}</span>
                    <span className="bootcamp-country-count-separator"> / </span>
                    <span className="bootcamp-country-count-total">{item.total || 0}</span>
                  </div>
                </div>

                <div className="bootcamp-country-progress-track">
                  <span
                    className="bootcamp-country-progress-fill"
                    style={{ width: `${progressPercent}%` }}
                  />
                </div>
              </article>
            );
          })}
        </div>

        <div className="bootcamp-top-countries-legend">
          <span>
            <i className="bootcamp-dot bootcamp-top-countries-dot-certified" />
            Certified
          </span>
          <span>
            <i className="bootcamp-dot bootcamp-top-countries-dot-total" />
            Total enrolled
          </span>
        </div>
      </div>
    </section>
  );
};

export default TopCountriesCertificationsCard;
